import React from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';

import { KeyboardDatePicker } from '@material-ui/pickers';
// import { KeyboardTimePicker } from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import TextFieldMoney from '../custom/TextField';

export default function FilterLogDialog({ children, ...props }) {
  //const initialDateStart = new Date(Date.now());
  //const initialDateEnd = new Date(Date.now());
  //initialDateStart.setMonth(initialDateStart.getMonth() - 1);

  const initialState = {
    // description: '',
    // from_account: '',
    // from_account_email: '',
    // from_account_name: '',
    // logtime_end: '', // decodeDate(initialDateEnd),
    // logtime_start: '', // decodeDate(initialDateStart),
    // owners: '',
    // owners_email: '',
    // owners_name: '',
    // to_account: '',
    // to_account_email: '',
    // to_account_name: '',
    // value_end: '',
    // value_start: '',
  };

  const [dateStart, setDateStart] = React.useState(null);
  const [dateEnd, setDateEnd] = React.useState(null);
  const { open, setOpen } = props;
  const [state, setState] = React.useState(initialState);

  function onFilterChanged() {
    if (props.filter === null) {
      reset();
    }
    return function filterChanged() { };
  }

  React.useEffect(onFilterChanged, [props.filter]);

  function decodeStartDate(date) {
    if (date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T00:00:00.000Z`;
    }
    return '';
  }

  function decodeEndDate(date) {
    if (date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T23:59:59.999Z`;
    }
    return '';
  }

  function handleApply(event) {
    event.preventDefault();
    if (props.setFilter) {
      props.setFilter(state);
    }
    setOpen(false);
  };

  function reset() {
    setDateStart(null);
    setDateEnd(null);
    setState(initialState);
    if (props.setFilter) {
      props.setFilter(null);
    }
  }

  function handleReset(event) {
    event.preventDefault();
    reset();
  };

  function handleCancel(event) {
    event.preventDefault();
    setOpen(false);
  };

  function handleChange(event) {
    event.preventDefault();
    setState({ ...state, [event.target.name]: event.target.value });
  };

  function handleDateStartChange(date) {
    setDateStart(date);
    setState({ ...state, logtime_start: decodeStartDate(date) });
  };

  function handleDateEndChange(date) {
    setDateEnd(date);
    setState({ ...state, logtime_end: decodeEndDate(date) });
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'sm'}
      onClose={handleCancel}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{props.title || 'Filtro'}</DialogTitle>
      <DialogContent>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container justifyContent="space-around">
            <Grid item>
              <KeyboardDatePicker
                margin="normal"
                id="logtime_start"
                label="A partir do dia"
                format="dd/MM/yyyy"
                value={dateStart}
                onChange={handleDateStartChange}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </Grid>
            <Grid item>
              <KeyboardDatePicker
                margin="normal"
                id="logtime_end"
                label="Até o dia"
                format="dd/MM/yyyy"
                value={dateEnd}
                onChange={handleDateEndChange}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
        <TextField
          id="description"
          name="description"
          label="Motivo"
          type="text"
          value={state.description}
          fullWidth={true}
          onChange={handleChange}
        />
        {props.show_owner_email &&
          <TextField
            id={"owners_email"}
            name={"owners_email"}
            label={"Email do responsável"}
            type={"text"}
            value={state.owners_email}
            fullWidth={true}
            onChange={handleChange}
          />
        }
        {props.show_owner_name &&
          <TextField
            id={"owners_name"}
            name={"owners_name"}
            label={"Nome do responsável"}
            type={"text"}
            value={state.owners_name}
            fullWidth={true}
            onChange={handleChange}
          />
        }
        {props.show_from_account &&
          <>
            <TextField
              id={"from_account_email"}
              name={"from_account_email"}
              label={"Email do cliente de origem"}
              type={"text"}
              value={state.from_account_email}
              fullWidth={true}
              onChange={handleChange}
            />
            <TextField
              id={"from_account_name"}
              name={"from_account_name"}
              label={"Nome do cliente de origem"}
              type={"text"}
              value={state.from_account_name}
              fullWidth={true}
              onChange={handleChange}
            />
          </>
        }
        {props.show_to_account &&
          <>
            <TextField
              id={"to_account_email"}
              name={"to_account_email"}
              label={"Email do cliente beneficiário"}
              type={"text"}
              value={state.to_account_email}
              fullWidth={true}
              onChange={handleChange}
            />
            <TextField
              id={"to_account_name"}
              name={"to_account_name"}
              label={"Nome do cliente beneficiário"}
              type={"text"}
              value={state.to_account_name}
              fullWidth={true}
              onChange={handleChange}
            />
          </>
        }
        <TextFieldMoney
          id="value_start"
          name="value_start"
          label="A partir do valor"
          type="text"
          value={state.value_start}
          fullWidth={true}
          onChange={handleChange}
        />
        <TextFieldMoney
          id="value_end"
          name="value_end"
          label="Até o valor"
          type="text"
          value={state.value_end}
          fullWidth={true}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleReset} color="primary">{'Limpar'}</Button>
        <Button onClick={handleCancel} color="primary">{'Cancelar'}</Button>
        <Button onClick={handleApply} color="primary">{'Aplicar'}</Button>
      </DialogActions>
    </Dialog>
  );
}
